import React, { Fragment } from 'react'
import Dropzone from 'react-dropzone-uploader';
import { Card, CardBody, Col, Form, FormGroup, Label, Row } from 'reactstrap'
import { H3, Btn } from '../../../../AbstractElements'
import { Add, Cancel, ProductImage, SelectSize, Size } from '../../../../Constant';

const Rightformdesc = ({ handlesavechange, register, handleSubmit, errors, setImageFile, saving }) => {

    // Capture the selected image file so the parent can send it as multipart.
    const handleImageChange = (fileWithMeta, status) => {
        if (setImageFile) {
            setImageFile(status === 'removed' ? null : fileWithMeta.file);
        }
    };

    return (
        <Fragment>
            <Col lg='6'>
                <Card>
                    <CardBody>
                        <div className='product-info'>
                            <H3>{ProductImage}</H3>
                            <Form id="form1" onSubmit={handleSubmit(handlesavechange)}>
                                <FormGroup>
                                    <Dropzone className="dropzone digits text-center h-25" maxFiles={1}
                                        multiple={false} height={100} canCancel={false} inputContent={'Upload Files Here'}
                                        accept="image/*" onChangeStatus={handleImageChange} />
                                </FormGroup>
                                <H3 attrH3={{ className: 'mt-4' }}>{SelectSize}</H3>
                                <div className='product-group'>
                                    <Row>
                                        <Col sm='12'>
                                            <FormGroup>
                                                <Label>{Size}</Label>
                                                <select id="exampleFormControlSelect6" name='size' className={`form-select ${(errors.size) && 'is-invalid'}`} {...register("size", { required: true })} >
                                                    <option value={'S'} >S</option>
                                                    <option value={'M'} >M</option>
                                                    <option value={'L'} >L</option>
                                                    <option value={'XL'} >XL</option>
                                                    <option value={'XXL'} >XXL</option>
                                                </select>
                                                <span className='text-danger'>{errors.size && 'Select Size of product '}</span>
                                            </FormGroup>
                                        </Col>
                                        <Col sm='12'>
                                            <FormGroup>
                                                <Label>SKU</Label>
                                                <input type='text' placeholder='Enter SKU' className={`form-control ${(errors.sku) && 'is-invalid'}`} name='sku' {...register("sku", { required: true })} />
                                                <span className='text-danger'>{errors.sku && 'SKU is required'}</span>
                                            </FormGroup>
                                        </Col>
                                        <Col sm='6'>
                                            <FormGroup>
                                                <Label>Wholesale Price (USD)</Label>
                                                <input type='number' step='0.01' placeholder='Wholesale $' className={`form-control ${(errors.wholesale_price_usd) && 'is-invalid'}`} name='wholesale_price_usd' {...register("wholesale_price_usd", { required: true })} />
                                                <span className='text-danger'>{errors.wholesale_price_usd && 'Add wholesale price (USD)'}</span>
                                            </FormGroup>
                                        </Col>
                                        <Col sm='6'>
                                            <FormGroup>
                                                <Label>Wholesale Price (EUR)</Label>
                                                <input type='number' step='0.01' placeholder='Wholesale €' className={`form-control ${(errors.wholesale_price) && 'is-invalid'}`} name='wholesale_price' {...register("wholesale_price", { required: true })} />
                                                <span className='text-danger'>{errors.wholesale_price && 'Add wholesale price (EUR)'}</span>
                                            </FormGroup>
                                        </Col>
                                        <Col sm='6'>
                                            <FormGroup>
                                                <Label>Wholesale Price (GBP)</Label>
                                                <input type='number' step='0.01' placeholder='Wholesale £' className='form-control' name='wholesale_price_gbp' {...register("wholesale_price_gbp")} />
                                                <span className='text-muted small'>Optional — GBP orders fall back to the EUR price</span>
                                            </FormGroup>
                                        </Col>
                                        <Col sm='6'>
                                            <FormGroup>
                                                <Label>Retail Price (EUR)</Label>
                                                <input type='number' step='0.01' placeholder='Retail €' className={`form-control ${(errors.retail_euro) && 'is-invalid'}`} name='retail_euro' {...register("retail_euro", { required: true })} />
                                                <span className='text-danger'>{errors.retail_euro && 'Add retail price (EUR)'}</span>
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                </div>
                            </Form>
                        </div>
                        <div className='mt-4'>
                            <div className='text-end'>
                                <Btn attrBtn={{ color: 'primary me-3', type: 'submit', form: 'form1', disabled: saving }}>{saving ? 'Saving…' : Add}</Btn>
                                <Btn attrBtn={{ color: 'danger', type: 'button', disabled: saving }}>{Cancel}</Btn>
                            </div>
                        </div>
                    </CardBody>
                </Card>
            </Col>
        </Fragment>
    )
}

export default Rightformdesc
